import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class NewsletterLogic extends Component {

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
  }

  get SELECTORS() {
    return {
      input: '[data-newsletter-input]',
      newsletterError: '[data-neswletter-error]'
    };
  }

// EXPORTED LOGIC
  checkSubmit(component) {
    // enable submit
    if (component.checkSubmitBtn) {
      component.checkSubmitBtn.addEventListener('click', () => this.enableSubmitBtn(component))
    }
  }

  // enable form submit button
  enableSubmitBtn(component) {
    let enable;
    // check submit enable
    enable = component.privacyCheckbox.checked;

    component.submitButton.disabled = !enable;
  }

  onFormSubmit(component) {
    if (component.form) {
      component.form.addEventListener('submit', e => {
        // preventing submitting form
        e.preventDefault();
        this.subscribeToNewsletter(component);
      });
    }
  }

  // END EXPORTED LOGIC

  // subscribe function
  subscribeToNewsletter(component) {
    // context of logic
    let logicCtx = this;
    // ctx of newsletter component
    let ctx = component;

    // vars
    let $this = component.form; // form
    let url = $this.getAttribute('action'); // form url
    let params = new URLSearchParams(new FormData($this)).toString();
    if (ctx.SELECTORS.newsletterBox) {
      let newsletterBox = ctx.newsletterBox;
    }
    let newsletterBox = ctx.$component;
    let eventsName = ctx.$component.dataset.jsEvents;
    let $submit = ctx.submitButton;
    // btn loading
    $submit.classList.add('--loading');
    $submit.disabled = true;
    // modal mode
    /*if ($this.closest('.modal').length) {
      url = url + '?xhr=true';
    }*/
    // adding loading class
    newsletterBox.classList.add('--loading');
    // show spinner loader
    ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
      button: $submit,
    });

    params = params.replace('fromFooter=false', 'fromFooter=true'); //TODO: remove after deprecation of firstName and lastName from API

    // ajax call
    ctx.$doAjax({
      type: 'POST',
      url: url,
      data: params
    })
      .done(res => {
        let html = new DOMParser().parseFromString(res, 'text/html');
        // parse result
        // searching errors
        let error = (html.querySelector(logicCtx.SELECTORS.newsletterError) !== null);
        // if input has error
        if (error) {
          // putting error class
          const inputParent = $this.querySelector(logicCtx.SELECTORS.input).parentNode;
          inputParent.classList.add('error');
          let spanError = html.querySelector(logicCtx.SELECTORS.newsletterError);
          // insert error in parent's parent
          if (!inputParent.parentNode.querySelector(logicCtx.SELECTORS.newsletterError)) {
            inputParent.parentNode.appendChild(spanError);
          }
          // emit event
          ctx.$emit(ctx.$customEvents[eventsName].error, {box: newsletterBox, html: html});
          // btn reset
          $submit.classList.remove('--loading');
          $submit.disabled = false;
        } else {
          // adding class to show thanks
          newsletterBox.classList.add(ctx.CLASSES.success);
          // emit event
          ctx.$emit(ctx.$customEvents[eventsName].subscribed, {box: newsletterBox});
          let trackingComponent = new TrackingComponent();
          trackingComponent.trackAction('newsletterSubscribe', $submit.dataset.trackingPosition, $submit);

        }
      })
      .fail(xhr => {
        console.error(`nl submit error:  ${$(this).serialize()}`);
      })
      .always(() => {
        // removing loading class
        newsletterBox.classList.remove('--loading');
        $submit.classList.remove('--loading');
        // hide spinner loader
        ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
          button: $submit,
        });
      });
  }

  afterSubscription(component) {
    //
  }

  manageNewsletterForm(component) {
    this.checkSubmit(component);
    this.onFormSubmit(component);
  }

  render() {
  }
}
